module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraLightItalic.f5080ea9.ttf";